import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CowtMasterService {

    constructor() { }

    private parseStoredValue(key: string): any {
        try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) : null;
        } catch {
            return null;
        }
    }

    getIdentityRoles(): string[] {
        const identityRoles = this.parseStoredValue('identityRoles');
        if (Array.isArray(identityRoles)) {
            return identityRoles;
        }

        const roles = this.parseStoredValue('roles');
        return Array.isArray(roles) ? roles : [];
    }

    setIdentityRoles(roles: string[]): void {
        if (Array.isArray(roles)) {
            localStorage.setItem('identityRoles', JSON.stringify(roles));
        }
    }

    getRolePermissions(): any {
        const roles = this.parseStoredValue('roles');
        return roles && !Array.isArray(roles) ? roles : null;
    }

    rightMatch(allowedRoles): boolean {
        const accessRole = this.getRolePermissions();
        const roleList = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];

        if (!accessRole) {
            return false;
        }

        return roleList.some(role => accessRole[role] === true);
    }
    GetCurrentCompanyId(): string {
        return localStorage.getItem("companyID");
    }
    GetCurrentBranchId(): string {
        return localStorage.getItem("branchID");
    }
    GetCurrentUserEmail(): string {
        return localStorage.getItem("userEmail");
    }
    checkCareOnWheelName(): string {
        return 'Care On Wheels Transportation';
    }

    isCourtesyCallerRole(): boolean {
        return this.getIdentityRoles().some(role => role === 'CourtesyCaller');
    }
}
